import styles from './ResetPassword.module.scss';
import { useTranslation } from '../../../../i18n/useTranslation';
import * as resetPasswordService from '../../../services/reset-password.service';
import { toast } from 'react-toastify';
import { ResetPasswordDataDto } from '../../models';
import LoginMenu from '../../../../components/login-menu/LoginMenu';
import BasicInformation from '../../../../components/basic-information/BasicInformation';
import { ChangeEvent, useState } from 'react';
import { Box, LinearProgress, TextField } from '@mui/material';
import ButtonGroupList, { ButtonItem } from '../../../../shared/button-group-list/button-group-list';
import { htmlId } from './reset-password.service';
import { useNavigate } from 'react-router-dom';

const setNewPasswordPageUrl = process.env.REACT_APP_RESET_PASSWORD_PAGE_URL as string;

// The only ERP exception type the client discriminates on here - ExceptionHandlingMiddleware only ever
// echoes an allow-listed exception's full type name, never an arbitrary internal one.
const USER_NOT_FOUND_EXCEPTION_TYPE = 'Nestoya.ERP.Auth.Exceptions.UserNotFoundException';

export default function ResetPassword() {
    const { t } = useTranslation('translation');
    const navigate = useNavigate();
    const [email, setEmail] = useState<string>('');
    const [emailError, setEmailError] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const actionButtons: ButtonItem[] = [
        { id: `${htmlId}-reset-password-btn`, label: t('resetPasswordForm.resetPassword') },
    ];

    const handleActionButtonClick = (id: string) => {
        switch (id) {
            case `${htmlId}-reset-password-btn`:
                handleSubmit();
                break;
        }
    };

    const validateEmail = (value: string): boolean => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(value);
    };

    const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
        setEmail(e.target.value);
    };

    const handleSubmit = (): void => {
        if (!email) {
            setEmailError(t('resetPasswordForm.EMAIL_IS_REQUIRED'));
        } else if (!validateEmail(email)) {
            setEmailError(t('resetPasswordForm.INCORRECT_EMAIL'));
        } else {
            setEmailError('');
            sendLink();
        }
    };

    const sendLink = () => {
        setIsLoading(true);
        const requestModel = {
            email: email,
            url: setNewPasswordPageUrl,
        } as ResetPasswordDataDto;
        resetPasswordService
            .sendLink(requestModel)
            .then((response) => {
                if (response) {
                    setIsLoading(false);
                    navigate('/reset-password-request-received');
                }
            })
            .catch((error) => {
                const data = error?.response?.data;
                let messageKey: string;
                if (data?.Message === 'resetPasswordForm.ACCOUNT_NOT_ACTIVATED') {
                    messageKey = 'resetPasswordForm.ACCOUNT_NOT_ACTIVATED';
                } else if (data?.ExceptionType === USER_NOT_FOUND_EXCEPTION_TYPE) {
                    messageKey = 'resetPasswordForm.EMAIL_NOT_FOUND';
                } else {
                    messageKey = 'commonErrors.UNEXPECTED_ERROR';
                }
                toast.error(t(messageKey), {
                    position: 'top-center',
                });
                setIsLoading(false);
            });
    };
    return (
        <div className={styles.wrapper}>
            <div className={styles.main_container}>
                <div className={styles.menu}>
                    <LoginMenu />
                </div>
                <div className={styles.form_container}>
                    <Box sx={{ width: '100%' }}>
                        <TextField
                            label={emailError || t('EMAIL')}
                            value={email}
                            onChange={handleChange}
                            error={!!emailError}

                            fullWidth
                            sx={{ marginRight: '0px' }}
                            size="small"
                            margin="normal"
                            id={`${htmlId}-email-input`}
                        />
                        {isLoading && (
                            <LinearProgress
                                sx={{
                                    marginBottom: '0.5rem',
                                    backgroundColor: '#b85353',
                                    '& .MuiLinearProgress-bar': {
                                        backgroundColor: '#821818',
                                    },
                                }}
                            />
                        )}
                        <ButtonGroupList
                            buttons={actionButtons}
                            size="small"
                            disabled={isLoading}
                            onClick={(id: string) => {
                                handleActionButtonClick(id);
                            }}
                        />
                    </Box>
                </div>

                <div className={styles.basic_information}>
                    <BasicInformation />
                </div>
            </div>
        </div>
    );
}
